import { toJS } from "mobx";
import { useEffect, useRef, useState } from "react";
import { FaChessRook, FaFileAlt, FaLanguage, FaPlus } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { IoPerson } from "react-icons/io5";
import {
  MdDeleteOutline,
} from "react-icons/md";
import { SiCoursera } from "react-icons/si";
import { RiPlantFill, RiSuitcaseLine } from "react-icons/ri";
import { HiSpeakerphone } from "react-icons/hi";
import {
  AiFillCloseCircle,
  AiOutlineRightCircle,
} from "react-icons/ai";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import ResumeOutput from "../resume/resume_output";
import HelpCenter from "../reusble_components/helpCenter";
import Resume1 from "../resume/Resumes/resume1";
import Resume2 from "../resume/Resumes/resume2";
import Resume3 from "./Resumes/resume3";
import Resume4 from "./Resumes/resume4";
import Resume5 from "./Resumes/resume5";
import Resume6 from "./Resumes/resume6";
import Resume7 from "./Resumes/resume7";
import Resume8 from "./Resumes/resume8";
import Resume9 from "./Resumes/resume9";
import Resume10 from "./Resumes/resume10";
import Resume11 from "./Resumes/resume11";
import Resume12 from "./Resumes/resume12";
import Resume13 from "./Resumes/resume13";
import Resume14 from "./Resumes/resume14";
import Resume15 from "./Resumes/resume15";
import Resume16 from "./Resumes/resume16";
import Resume17 from "./Resumes/resume17";
import Resume18 from "./Resumes/resume18";
import Resume19 from "./Resumes/resume19";
import Resume20 from "./Resumes/resume20";
// import ColorPicker from "./colorPicker";

export default function ResumeTotal() {
  const { ResumeStore } = useStores();
  const [showLanguages, setShowLanguages] = useState(true);
  const [showCourses, setShowCourses] = useState(false);
  const [showInternships, setShowInternships] = useState(false);
  const [showReferences, setShowReferences] = useState(false);
  const [showHobbies, setShowHobbies] = useState(false);
  const [showExtraCurricular, setShowExtraCurricular] = useState(false);
  const h1Ref = useRef(null);
  const [showResume, setShowResume] = useState(false);
  const [resumes, setResumes] = useState(false);
  const { CommonStore } = useStores();
  // const { ResumeStore } = useStores();
  // const [showColorPicker, setShowColorPicker] = useState(false);
  // const [showColorPicker1, setShowColorPicker1] = useState(false);
  // const [showCustomSection, setShowCustomSection] = useState(false);
  // const [customSection, setCustomSection] = useState([]);

  const coursesRef = useRef(null);
  const internshipsRef = useRef(null);
  const referencesRef = useRef(null);
  const hobbiesRef = useRef(null);
  const extraCurricularRef = useRef(null);
  const languagesRef = useRef(null);

  const scrollToTop = () => {
    try {
      if (h1Ref.current) {
        h1Ref.current.scrollIntoView({ behavior: "instant" });
      }
    } catch (error) {}
  };

  useEffect(() => {
    scrollToTop();
    // CommonStore.setShowHeaderInDashboard(false);

    // return () => {
    //     CommonStore.setShowHeaderInDashboard(true);
    // }
  }, []);

  const handleShowSection = (ref) => {
    setTimeout(() => {
      try {
        if (ref.current) {
          ref.current.scrollIntoView({ behavior: "smooth" });
        }
      } catch (error) {
        console.log(error);
      }
    }, 100);
  };

  const handleShowLanguages = () => {
    handleShowSection(languagesRef);
    setShowLanguages(!showLanguages);
  };

  const handleShowCourses = () => {
    handleShowSection(coursesRef);
    setShowCourses(!showCourses);
  };

  const handleShowInternships = () => {
    handleShowSection(internshipsRef);
    setShowInternships(!showInternships);
  };

  const handleShowReferences = (ref) => {
    handleShowSection(referencesRef);
    setShowReferences(!showReferences);
  };

  const handleShowHobbies = (ref) => {
    handleShowSection(hobbiesRef);
    setShowHobbies(!showHobbies);
  };

  const handleShowExtraCurricular = (ref) => {
    handleShowSection(extraCurricularRef);
    setShowExtraCurricular(!showExtraCurricular);
  };

  // const handleShowCustomSection = () => {
  //     setShowCustomSection(true);
  // }

  // const handleAddCustomSection = () => {
  //     setCustomSection([...customSection, {}]);
  // }

  // const handleRemoveCustomSection = (index) => {
  //     setCustomSection(customSection.filter((_,index) => index !== customSection.length - 1))
  // }

  // const handleChange = (color) => {
  //     try {
  //         ResumeStore.setPrimaryColor(color.hex);
  //         console.log(ResumeStore.resumeBuilder.primaryColor);
  //     } catch (error) {

  //     }
  // }

  // const handleSecondaryChange = (color) => {
  //     try {
  //         ResumeStore.setSecondaryColor(color.hex);
  //         console.log(ResumeStore.resumeBuilder.secondaryColor);
  //     } catch (error) {

  //     }
  // }

  // const handlePrimaryColorPickerClose = () => {
  //     setShowColorPicker(false);
  // };

  // const handleSecondaryColorPickerClose = () => {
  //     setShowColorPicker1(false);
  // };

  // const handleButtonClick = () => {
  //     setShowColorPicker(!showColorPicker);
  //     setShowColorPicker1(false);
  // };

  // const handleButtonClick1 = () => {
  //     setShowColorPicker1(!showColorPicker1);
  //     setShowColorPicker(false);
  // };

  const handleShowResume = () => {
    setShowResume(!showResume);
  };
  const clear = () => {
    window.location.reload();
  };

  const Resumes = [
    {
      id: 0,
      action: <ResumeOutput />,
      name: "Resume",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume.0dd4d4ad00d36b10790a.png",
    },
    {
      id: 1,
      action: <Resume1 />,
      name: "Resume 1",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume1.png",
    },
    {
      id: 2,
      action: <Resume2 />,
      name: "Resume 2",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png",
    },
    {
      id: 3,
      action: <Resume3 />,
      name: "Resume 3",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume3.png",
    },
    {
      id: 4,
      action: <Resume4 />,
      name: "Resume 4",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume4.png",
    },
    {
      id: 5,
      action: <Resume5 />,
      name: "Resume 5",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume5.png",
    },
    {
      id: 6,
      action: <Resume6 />,
      name: "Resume 6",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume6.png",
    },
    {
      id: 7,
      action: <Resume7 />,
      name: "Resume 7",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume7.png",
    },
    {
      id: 8,
      action: <Resume8 />,
      name: "Resume 8",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume8.png",
    },
    {
      id: 9,
      action: <Resume9 />,
      name: "Resume 9 ",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume9.png",
    },
    {
      id: 10,
      action: <Resume10 />,
      name: "Resume 10",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume10.png",
    },
    {
      id: 11,
      action: <Resume11 />,
      name: "Resume 11",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume11.png",
    },
    {
      id: 12,
      action: <Resume12 />,
      name: "Resume 12",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume12.png",
    },
    {
      id: 13,
      action: <Resume13 />,
      name: "Resume 13",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume13.png",
    },
    {
      id: 14,
      action: <Resume14 />,
      name: "Resume 14",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume14.png",
    },
    {
      id: 15,
      action: <Resume15 />,
      name: "Resume 15",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume15.png",
    },
    {
      id: 16,
      action: <Resume16 />,
      name: "Resume 16",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume16.png",
    },
    {
      id: 17,
      action: <Resume17 />,
      name: "Resume 17",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume17.png",
    },
    {
      id: 18,
      action: <Resume18 />,
      name: "Resume 18",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume18.png",
    },
    {
      id: 19,
      action: <Resume19 />,
      name: "Resume 19",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume19.png",
    },
    {
      id: 20,
      action: <Resume20 />,
      name: "Resume 20",
      imageUrl:
        "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume20.png",
    },
    // {
    //   id: 17,
    //   action: <Resume17 />,
    //   name: "Resume 17",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 18,
    //   action: <Resume18 />,
    //   name: "Resume 18",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 19,
    //   action: <Resume19 />,
    //   name: "Resume 19",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 20,
    //   action: <Resume20 />,
    //   name: "Resume 20",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 21,
    //   action: <Resume21 />,
    //   name: "Resume 21",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 22,
    //   action: <Resume22 />,
    //   name: "Resume 22",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 23,
    //   action: <Resume23 />,
    //   name: "Resume 23",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 24,
    //   action: <Resume24 />,
    //   name: "Resume 24",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // },
    // {
    //   id: 25,
    //   action: <Resume25 />,
    //   name: "Resume 25",
    //   imageUrl: "https://reaidystorage.blob.core.windows.net/spotmiespublic/resume2.png"
    // }
  ];

  const [selectedResumeId, setSelectedResumeId] = useState(0);
  const [template, setTemplate] = useState(true);

  const handleResumeClick = (id) => {
    setSelectedResumeId(id);
    setResumes(false);
    console.log("Selected Resume Id: ", id);
  };

  return useObserver(() => (
    <div ref={h1Ref} className="gil-reg flex w-[100%] py-12 md:py-0">
      <HelpCenter />
      {resumes && (
        <div
          onClick={() => setResumes(false)}
          className="absolute w-full h-full z-50 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[70%] lg:w-[70%] w-full h-[80%] md:mx-[10%] my-[5%] shadow-lg"
          >
            <AiFillCloseCircle
              className="text-primary absolute text-2xl cursor-pointer top-2 right-2"
              onClick={() => setResumes(false)}
            />
            <h1 className="text-black text-xl font-semibold my-[1%]">
              Choose one of the following Templates
            </h1>
            <div className="flex flex-row flex-wrap mx-[3%]">
              {Resumes.map((resume) => (
                <div
                  key={resume.id}
                  className={`flex items-center justify-between m-2 mx-5 border-2 ${
                    resume.id === selectedResumeId
                      ? "border-primary"
                      : "border-gray-500"
                  }`}
                >
                  <button
                    onClick={() => handleResumeClick(resume.id)}
                    className="lg:text-2xl w-[100px] h-[100px]"
                  >
                    <img
                      className="w-[100px] h-[100px]"
                      src={resume.imageUrl}
                      alt={`Resume ${resume.id}`}
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {ResumeStore.resumeShow ? (
        Resumes.find((resume) => resume.id === selectedResumeId)?.action
      ) : (
        <>
          <div className="flex flex-col md:w-[50%] lg:w-[50%] max-w-full bg-bg3">
            {/* <div className="w-[90%] mx-auto my-4">
                            <h1 className="text-2xl font-semibold">Colors</h1>
                            <div className="flex flex-wrap gap-2 mt-2">
                                <div className="cursor-pointer flex items-center gap-2 w-[45%]">
                                    <button className="">Primary color</button>
                                    <div onClick={handleButtonClick} className={`w-8 h-8 `}
                                        style={{
                                            backgroundColor: ResumeStore.resumeBuilder.primaryColor,
                                        }} />

                                </div>

                                <div className="cursor-pointer flex items-center gap-2 w-[45%]">
                                    <button className="">Secondary color</button>
                                    <div onClick={handleButtonClick1} className={`w-8 h-8 `}
                                        style={{
                                            backgroundColor: ResumeStore.resumeBuilder.secondaryColor,
                                        }} />

                                </div>
                                <div className="cursor-pointer flex items-center gap-2 w-[45%]">
                                    <button className="">TextColor</button>
                                    <div onClick={handleButtonClick1} className={`w-8 h-8 `}
                                        style={{
                                            backgroundColor: ResumeStore.resumeBuilder.textColor,
                                        }} />

                                </div>
                                {showColorPicker && (
                                    <ColorPicker color={ResumeStore.resumeBuilder.primaryColor} handleChange={handleChange} onClose={handlePrimaryColorPickerClose} />
                                )}
                                {showColorPicker1 && (
                                    <ColorPicker color={ResumeStore.resumeBuilder.secondaryColor} handleChange={handleSecondaryChange} onClose={handleSecondaryColorPickerClose} />
                                )}
                            </div>
                        </div> */}
            <div className="w-[90%] mx-auto my-4">
              <PersonalDetails />
            </div>
            <div className="w-[90%] mx-auto my-4">
              <ProfessionalSummary />
            </div>
            <div className="w-[90%] mx-auto my-4">
              <EmploymentHistory />
            </div>
            <div className="w-[90%] mx-auto my-4">
              <Education />
            </div>
            <div className="w-[90%] mx-auto my-4">
              <Websites />
            </div>
            <div className="w-[90%] mx-auto my-4">
              <Skills />
            </div>
            {showInternships && (
              <div ref={internshipsRef} className="w-[90%] mx-auto my-4">
                <Internships handleShowInternships={handleShowInternships} />
              </div>
            )}
            {showCourses && (
              <div ref={coursesRef} className="w-[90%] mx-auto my-4">
                <Courses />
              </div>
            )}
            {showReferences && (
              <div ref={referencesRef} className="w-[90%] mx-auto my-4">
                <References />
              </div>
            )}
            {showHobbies && (
              <div ref={hobbiesRef} className="w-[90%] mx-auto my-4">
                <Hobbies handleShowHobbies={handleShowHobbies} />
              </div>
            )}
            {showExtraCurricular && (
              <div ref={extraCurricularRef} className="w-[90%] mx-auto my-4">
                <ExtraCurricular
                  handleShowExtraCurricular={handleShowExtraCurricular}
                />
              </div>
            )}
            {/* {showCustomSection && (
                    
                   <>
                    {
                        customSection.map((item,index) => (
                            <div className="w-[90%] mx-auto my-4">
                                 <CustomSection index={index} handleRemoveCustomSection={handleRemoveCustomSection}  />
                            </div>
                        ))
                    }
                   </>
                   
                )} */}
            {showLanguages && (
              <div ref={languagesRef} className="w-[90%] mx-auto my-4">
                <Languages />
              </div>
            )}
            <div className="w-[90%] mx-auto my-4">
              <AddSection
                handleShowLanguages={handleShowLanguages}
                handleShowCourses={handleShowCourses}
                handleShowInternships={handleShowInternships}
                handleShowReferences={handleShowReferences}
                handleShowHobbies={handleShowHobbies}
                handleShowExtraCurricular={handleShowExtraCurricular}
                // handleShowCustomSection={handleShowCustomSection}
                language={showLanguages}
                course={showCourses}
                internship={showInternships}
                reference={showReferences}
                hobbies={showHobbies}
                extraCurricular={showExtraCurricular}
                // customSection={showCustomSection}
                // handleAddCustomSection={handleAddCustomSection}
              />
            </div>
            <div>
              {/* <button
                onClick={() => setShowResume(true)}
                className="rounded-lg text-white m-4 bg-primary  py-2 lg:py-4 w-56 lg:w-72 lg:text-2xl">
                Show Resume
              </button> */}
              <button
                onClick={clear}
                className="rounded-lg text-primary border-2 border-primary mt-0 mb-[32px] ml-4 bg-white  py-2 lg:py-4 lg:text-2xl w-[10rem] lg:w-72"
              >
                Clear
              </button>
            </div>
            <button
              onClick={() => ResumeStore.setResumeShow(true)}
              className="fixed bottom-40 md:bottom-2 right-4 md:hidden lg:hidden block bg-primary text-white rounded-full p-4"
            >
              <FaFileAlt className="w-8 h-8" />
            </button>
          </div>
          <div className="md:flex md:flex-col lg:flex lg:flex-col hidden md:w-[50%] lg:w-[50%] w-full">
            <div className="flex justify-around mr-[2%] items-center">
              <h1 className="text-xl w-full text-start">
                Choose one of the following Templates
              </h1>
              <button
                className="text-primary text-sm  underline md:w-[110px]"
                onClick={() => setTemplate(!template)}
              >
                {!template ? "Show Templets" : "Hide Templets"}
              </button>
            </div>
            {template && (
              <div className="flex flex-row flex-wrap ">
                {Resumes.slice(0, 5).map((resume) => (
                  <div
                    key={resume.id}
                    className={`flex items-center justify-between m-2 border-2 ${
                      resume.id === selectedResumeId
                        ? "border-primary"
                        : "border-gray-500"
                    } `}
                  >
                    <button
                      onClick={() => {
                        handleResumeClick(resume.id);
                      }}
                      className="flex items-center lg:text-2xl w-[100px] h-[100px]"
                    >
                      <img
                        className="w-[100px] h-[100px]"
                        src={resume.imageUrl}
                        alt={`Resume ${resume.id}`}
                      />
                    </button>
                  </div>
                ))}
                <div
                  className={`flex flex-col items-center justify-center my-2 text-primary`}
                >
                  <div>
                    <AiOutlineRightCircle
                      className="text-6xl"
                      onClick={() => {
                        setResumes(true);
                      }}
                    />
                  </div>
                  <button
                    className="flex justify-center text-sm items-center "
                    onClick={() => {
                      setResumes(true);
                    }}
                  >
                    View More
                  </button>
                </div>
              </div>
            )}
            {/* <ResumeOutput />
            <Resume1 />
            <Resume2 />
            <Resume3 />
            <Resume4 /> */}
            {Resumes.find((resume) => resume.id === selectedResumeId)?.action}
          </div>
        </>
      )}
    </div>
  ));
}

export function PersonalDetails() {
  const { ResumeStore } = useStores();
  const [email, setEmail] = useState(
    ResumeStore.resumeBuilder.personalDetails?.email || ""
  );
  const [emailError, setEmailError] = useState("");
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const titleref = useRef(null);
  const firstNameref = useRef(null);
  const lastNameref = useRef(null);
  const emailref = useRef(null);
  const phoneref = useRef(null);
  const countryref = useRef(null);
  const cityref = useRef(null);
  const addressref = useRef(null);
  const postalCoderef = useRef(null);
  const licenseref = useRef(null);
  const nationalityref = useRef(null);
  const placeOfBirthref = useRef(null);
  const dateOfBirthref = useRef(null);
  const profileInputRef = useRef(null);

  const updatePersonalDetails = (e) => {
    const name = e.target?.name;
    const value = e.target?.value;

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }
    }

    ResumeStore.updatePersonalDetails(name, value);
    console.log(ResumeStore.resumeBuilder.personalDetails.jobTitle);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const openFiles = () => {
    profileInputRef.current.click();
  };

  const changeImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log(file);
      const imageUrl = URL.createObjectURL(file);
      ResumeStore.setProfile(imageUrl);
    }
  };
  const handleDateInput = (e) => {
    let value = e.target.value;

    // Validate and truncate the year part if it exceeds 4 digits
    const dateParts = value.split("-");
    if (dateParts[0] && dateParts[0].length > 4) {
      dateParts[0] = dateParts[0].slice(0, 4); // Keep only the first 4 digits
      e.target.value = dateParts.join("-");
    }

    // Update the store with the validated value
    ResumeStore.updatePersonalDetails(e.target.name, e.target.value);
  };

  return useObserver(() => (
    <div className="lg:text-xl pt-6 md:pt-8">
      {" "}
      {/* Added pt-6 for padding */}
      <div className="flex justify-between">
        <h1 className="text-2xl font-semibold lg:text-3xl text-orange-500">
          Personal Details
        </h1>
        <p
          className="text-sm px-3 text-primary cursor-pointer mt-2 md:mt-2 lg:mt-2 lg:text-xl"
          onClick={ResumeStore.autofill}
        >
          Auto Fill
        </p>
      </div>
      <div className="flex md:mx-2 lg:mx-2 mx-0 flex-wrap w-full mt-2 justify-between">
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">
            Wanted Job Title{" "}
          </label>
          <input
            ref={titleref}
            name="jobTitle"
            value={ResumeStore.resumeBuilder.personalDetails?.jobTitle}
            onChange={updatePersonalDetails}
            type="text"
            className="focus:border-b-2 focus:border-primary px-2 py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
            placeholder="e.g. Web Developer"
          />
        </div>
        <div className="flex md:w-[45%] lg:w-[45%] w-full  mt-4 mb-2 items-center">
          {ResumeStore.resumeBuilder.profile ? (
            <>
              <img
                src={ResumeStore.resumeBuilder.profile}
                alt=""
                className="w-14 h-14 object-cover rounded"
              />
            </>
          ) : (
            <div className="bg-secondary2  w-14 rounded h-14 text-center text-text_color5 text-3xl flex justify-center items-center">
              <IoPerson />
            </div>
          )}
          <p
            onClick={openFiles}
            className="text-sm px-3 text-primary cursor-pointer lg:text-xl"
          >
            {ResumeStore.resumeBuilder.profile
              ? "Change Photo"
              : "Upload Photo"}
          </p>
          <input
            type="file"
            accept=".png, .jpeg, .jpg"
            ref={profileInputRef}
            className="hidden"
            onChange={changeImage}
          />
        </div>
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">
            First Name
          </label>
          <input
            ref={firstNameref}
            value={ResumeStore.resumeBuilder.personalDetails?.firstName}
            name="firstName"
            onChange={updatePersonalDetails}
            type="text"
            className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
          />
        </div>
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">
            Last Name
          </label>
          <input
            ref={lastNameref}
            value={ResumeStore.resumeBuilder.personalDetails?.lastName}
            name="lastName"
            onChange={updatePersonalDetails}
            type="text"
            className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
          />
        </div>
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">
            Email ID
          </label>
          <input
            ref={emailref}
            value={ResumeStore.resumeBuilder.personalDetails?.email}
            name="email"
            onChange={updatePersonalDetails}
            type="email"
            className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
          />
          {emailError && (
            <p className="text-red-500 text-sm mt-1">{emailError}</p>
          )}
        </div>
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">Phone</label>
          <input
            ref={phoneref}
            value={ResumeStore.resumeBuilder.personalDetails?.phone}
            name="phone"
            onChange={updatePersonalDetails}
            type="text"
            className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
          />
        </div>
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">
            Country
          </label>
          <input
            ref={countryref}
            value={ResumeStore.resumeBuilder.personalDetails?.country}
            name="country"
            onChange={updatePersonalDetails}
            type="text"
            className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
          />
        </div>
        <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
          <label className="text-sm text-text_color5 lg:text-2xl">City</label>
          <input
            ref={cityref}
            value={ResumeStore.resumeBuilder.personalDetails?.city}
            name="city"
            onChange={updatePersonalDetails}
            type="text"
            className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
          />
        </div>
        {showAdditionalDetails && (
          <>
            <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
              <label className="text-sm text-text_color5 lg:text-2xl">
                Address
              </label>
              <input
                ref={addressref}
                value={ResumeStore.resumeBuilder.personalDetails?.address}
                name="address"
                onChange={updatePersonalDetails}
                type="text"
                className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
              />
            </div>
            {/* <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
                                <label className="text-sm text-text_color5">Postal Code</label>
                                <input ref={postalCoderef} name="postalCode" onChange={updatePersonalDetails} type="text" className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-secondary2 focus:outline-none" />
                            </div>
                            <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
                                <label className="text-sm text-text_color5">Driving License</label>
                                <input ref={licenseref} name="drivingLicense" onChange={updatePersonalDetails} type="text" className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-secondary2 focus:outline-none" />
                            </div>
                            <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
                                <label className="text-sm text-text_color5">Nationality</label>
                                <input ref={nationalityref} name="nationality" onChange={updatePersonalDetails} type="text" className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-secondary2 focus:outline-none" />
                            </div> */}
            {/* <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
                                <label className="text-sm text-text_color5">Place Of Birth</label>
                                <input ref={placeOfBirthref} name="placeOfBirth" onChange={updatePersonalDetails} type="text" className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-secondary2 focus:outline-none" />
                            </div> */}
            <div className="flex flex-col my-2 md:w-[45%] lg:w-[45%] w-full items-start">
              <label className="text-sm text-text_color5 lg:text-2xl">
                Date Of Birth
              </label>
              <input
                ref={dateOfBirthref}
                value={ResumeStore.resumeBuilder.personalDetails?.dateOfBirth}
                name="dateOfBirth"
                onChange={updatePersonalDetails}
                type="date"
                onInput={handleDateInput}
                className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full lg:h-14 bg-secondary2 focus:outline-none"
              />
            </div>
          </>
        )}
        {!showAdditionalDetails ? (
          <button
            className="text-primary flex items-center lg:text-2xl"
            onClick={() => setShowAdditionalDetails(true)}
          >
            Edit additional details <IoIosArrowDown className="ml-1" />
          </button>
        ) : (
          <button
            className="text-primary flex items-center lg:text-2xl"
            onClick={() => setShowAdditionalDetails(false)}
          >
            Hide additional details <IoIosArrowUp className="ml-1" />
          </button>
        )}
      </div>
    </div>
  ));
}

export function ProfessionalSummary() {
  const descriptionRef = useRef(null);
  const { ResumeStore } = useStores();

  const updateSummary = (e) => {
    const value = e.target.value;
    ResumeStore.updateProfileSummary(value);
  };

  return useObserver(() => (
    <div className="lg:text-xl">
      <h1 className="text-2xl font-semibold lg:text-3xl">
        Professional Summary
      </h1>
      <p className=" text-text_color5 text-sm cursor-default lg:text-xl">
        Write 2-4 short & energetic sentences to interest the reader! Mention
        your role, experience & most importantly - your biggest achievements,
        best qualities and skills.
      </p>
      <textarea
        ref={descriptionRef}
        value={ResumeStore.resumeBuilder.profileSummary}
        name="profileSummary"
        onChange={updateSummary}
        className="w-full focus:border-b-2 focus:border-primary  mt-4 bg-secondary2 focus:outline-none md:h-[40vh] lg:h-[40vh] h-[30vh]  p-2"
        placeholder="e.g. ....."
      />
      <div className="text-text_color5 text-sm flex justify-between items-center lg:text-xl">
        <p className="md:w-[90%] lg:w-[90%] w-[80%] lg:text-xl">
          Recruiter tip: write 50-200 characters to increase interview chances
        </p>
        <p>0 / 50+</p>
      </div>
    </div>
  ));
}

export function EmploymentHistory() {
  // const [employmentHistory, setEmploymentHistory] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ResumeStore } = useStores();

  const titleRef = useRef(null);
  const employerRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const cityRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleAdd = () => {
    // setEmploymentHistory([...employmentHistory, {}])
    ResumeStore.setEmployementHistory({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setEmploymentHistory(employmentHistory.filter((item,index) => index !== employmentHistory.length - 1))
    ResumeStore.removeEmployementHistory(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateEmployementHistory = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateEmployementHistory(name, value, index);
    // console.log(ResumeStore.resumeBuilder.EmployementHistory[index].jobTitle);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between  bg-secondary2`}
          >
            <p className="text-sm lg:text-xl">
              {ResumeStore.resumeBuilder.employementHistory[index]?.jobTitle ||
                "Add JobTitle "}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between lg:text-xl ">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Job Title
                </label>
                <input
                  type="text"
                  ref={titleRef}
                  name="jobTitle"
                  value={
                    ResumeStore.resumeBuilder.employementHistory[index]
                      ?.jobTitle
                  }
                  onChange={(e) => updateEmployementHistory(e, index)}
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Employer
                </label>
                <input
                  ref={employerRef}
                  name="company"
                  value={
                    ResumeStore.resumeBuilder.employementHistory[index]?.company
                  }
                  onChange={(e) => updateEmployementHistory(e, index)}
                  type="text"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Start Date
                </label>
                <input
                  name="startDate"
                  value={
                    ResumeStore.resumeBuilder.employementHistory[index]
                      ?.startDate
                  }
                  onChange={(e) => updateEmployementHistory(e, index)}
                  ref={startDateRef}
                  type="date"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  End Date
                </label>
                <input
                  name="endDate"
                  value={
                    ResumeStore.resumeBuilder.employementHistory[index]?.endDate
                  }
                  onChange={(e) => updateEmployementHistory(e, index)}
                  ref={endDateRef}
                  type="date"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  City
                </label>
                <input
                  name="city"
                  value={
                    ResumeStore.resumeBuilder.employementHistory[index]?.city
                  }
                  onChange={(e) => updateEmployementHistory(e, index)}
                  ref={cityRef}
                  type="text"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="my-2 w-full">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Description
                </label>
                <textarea
                  name="description"
                  value={
                    ResumeStore.resumeBuilder.employementHistory[index]
                      ?.description
                  }
                  onChange={(e) => updateEmployementHistory(e, index)}
                  ref={descriptionRef}
                  className="w-full focus:border-b-2 focus:border-primary  bg-gray-300 focus:outline-none md:h-[40vh] lg:h-[40vh] h-[30vh] p-2"
                  placeholder="e.g. ....."
                />
                <div className="text-text_color5 text-sm flex justify-between items-center lg:text-xl">
                  <p className="md:w-[90%] lg:w-[90%] w-[80%]">
                    Recruiter tip: write 50-200 characters to increase interview
                    chances
                  </p>
                  <p>0 / 50+</p>
                </div>
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold lg:text-3xl">Employment History</h1>
      <p className=" text-text_color5 text-sm cursor-default lg:text-xl">
        Show your relevant experience (last 10 years). Use bullet points to note
        your achievements, if possible - use numbers/facts (Achieved X, measured
        by Y, by doing Z).
      </p>
      {ResumeStore.resumeBuilder.employementHistory.map((item, index) => (
        <Details key={index} index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1 lg:text-2xl"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.employementHistory.length > 0
          ? " Add one more Employment"
          : " Add Employment"}{" "}
      </button>
    </>
  ));
}

export function Education() {
  // const [educationSection, setEducationSection] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ResumeStore } = useStores();

  const schoolref = useRef(null);
  const degreeref = useRef(null);
  const startDateref = useRef(null);
  const endDateref = useRef(null);
  const cityref = useRef(null);
  const descriptionref = useRef(null);

  const handleAdd = () => {
    // setEducationSection([...educationSection, {}])
    ResumeStore.setEducation({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setEducationSection(educationSection.filter((_,index) => index !== educationSection.length - 1))
    ResumeStore.removeEducation(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateEducation = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateEducation(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm ">
              {ResumeStore.resumeBuilder.education[index]?.degree ||
                "Add degree"}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between lg:text-xl">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  College/University
                </label>
                <input
                  type="text"
                  name="school"
                  value={ResumeStore.resumeBuilder.education[index]?.school}
                  onChange={(e) => updateEducation(e, index)}
                  ref={schoolref}
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Degree
                </label>
                <input
                  name="degree"
                  value={ResumeStore.resumeBuilder.education[index]?.degree}
                  onChange={(e) => updateEducation(e, index)}
                  ref={degreeref}
                  type="text"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Start Date
                </label>
                <input
                  name="startDate"
                  value={ResumeStore.resumeBuilder.education[index]?.startDate}
                  onChange={(e) => updateEducation(e, index)}
                  ref={startDateref}
                  type="date"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  End Date
                </label>
                <input
                  name="endDate"
                  value={ResumeStore.resumeBuilder.education[index]?.endDate}
                  onChange={(e) => updateEducation(e, index)}
                  ref={endDateref}
                  type="date"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  City
                </label>
                <input
                  name="city"
                  value={ResumeStore.resumeBuilder.education[index]?.city}
                  onChange={(e) => updateEducation(e, index)}
                  ref={cityref}
                  type="text"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="my-2 w-full">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Description
                </label>
                <textarea
                  name="description"
                  value={
                    ResumeStore.resumeBuilder.education[index]?.description
                  }
                  onChange={(e) => updateEducation(e, index)}
                  ref={descriptionref}
                  className="w-full focus:border-b-2 focus:border-primary  bg-gray-300 focus:outline-none md:h-[40vh] lg:h-[40vh] h-[30vh] p-2"
                  placeholder="e.g. ....."
                />
                <div className="text-text_color5 text-sm flex justify-between items-center lg:text-xl">
                  <p className="md:w-[90%] lg:w-[90%] w-[80%] ">
                    Recruiter tip: write 50-200 characters to increase interview
                    chances
                  </p>
                  <p>0 / 50+</p>
                </div>
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold lg:text-3xl">Education</h1>
      <p className=" text-text_color5 text-sm cursor-default lg:text-xl">
        A varied education on your resume sums up the value that your learnings
        and background will bring to job.
      </p>
      {ResumeStore.resumeBuilder.education.map((item, index) => (
        <Details index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1 lg:text-2xl"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.education.length > 0
          ? " Add one more Education"
          : " Add Education"}{" "}
      </button>
    </>
  ));
}

export function Websites() {
  // const [links, setLinks] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ResumeStore } = useStores();

  const labelref = useRef(null);
  const linkref = useRef(null);

  const handleAdd = () => {
    // setLinks([...links, {}])
    ResumeStore.setWebsites({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setLinks(links.filter((_,index) => index !== links.length - 1))
    ResumeStore.removeWebsites(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateWebsites = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateWebsites(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm lg:text-xl">
              {ResumeStore.resumeBuilder.websites[index]?.link || "Add link "}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between lg:text-xl">
              <div className="flex flex-col my-2 w-[45%] items-start ">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Label
                </label>
                <input
                  type="text"
                  name="label"
                  value={ResumeStore.resumeBuilder.websites[index]?.label}
                  onChange={(e) => updateWebsites(e, index)}
                  ref={labelref}
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5 lg:text-xl">
                  Link
                </label>
                <input
                  name="link"
                  value={ResumeStore.resumeBuilder.websites[index]?.link}
                  onChange={(e) => updateWebsites(e, index)}
                  ref={linkref}
                  type="text"
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return (
    <>
      <h1 className="text-2xl font-semibold lg:text-3xl">
        Websites & Social Links
      </h1>
      <p className=" text-text_color5 text-sm cursor-default lg:text-xl">
        You can add links to websites you want hiring managers to see! Perhaps
        It will be a link to your portfolio, LinkedIn profile, or personal
        website
      </p>
      {ResumeStore.resumeBuilder.websites.map((item, index) => (
        <Details index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1 lg:text-2xl"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.websites.length > 0
          ? " Add one more Link"
          : " Add Link"}{" "}
      </button>
    </>
  );
}

export function Languages() {
  // const [languages, setLanguages] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ResumeStore } = useStores();

  const languageref = useRef(null);
  const levelref = useRef(null);

  const handleAdd = () => {
    // setLanguages([...languages, {}])
    ResumeStore.setLanguages({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setLanguages(languages.filter((_,index) => index !== languages.length - 1))
    ResumeStore.removeLanguages(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateLanguages = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateLanguages(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm ">
              {ResumeStore.resumeBuilder.languages[index]?.language ||
                "Add a Language"}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between ">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Language</label>
                <input
                  type="text"
                  name="language"
                  value={ResumeStore.resumeBuilder.languages[index]?.language}
                  onChange={(e) => updateLanguages(e, index)}
                  ref={languageref}
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Level</label>
                <select
                  name="level"
                  value={ResumeStore.resumeBuilder.languages[index]?.level}
                  onChange={(e) => updateLanguages(e, index)}
                  className="px-2 focus:border-b-2 focus:border-primary  py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  placeholder="Select Level"
                  ref={levelref}
                >
                  <option value="Select Level">Select Level</option>
                  <option value="native speaker">Native Speaker </option>
                  <option value="highly proficient">Highly proficient</option>
                  <option value="very good command">Very good command</option>
                </select>
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold">Languages</h1>
      {ResumeStore.resumeBuilder.languages.map((item, index) => (
        <Details index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.languages.length > 0
          ? " Add one more Language"
          : " Add Language"}{" "}
      </button>
    </>
  ));
}

export function Courses() {
  // const [courses, setCourses] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ResumeStore } = useStores();

  const courseref = useRef(null);
  const institutionref = useRef(null);
  const startDateref = useRef(null);
  const endDateref = useRef(null);

  const handleAdd = () => {
    // setCourses([...courses, {}])
    ResumeStore.setCourses({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setCourses(courses.filter((_,index) => index !== courses.length - 1))
    ResumeStore.removeCourses(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateCourses = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateCourses(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm ">
              {ResumeStore.resumeBuilder.courses[index]?.course ||
                "Add a Course"}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between ">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Course</label>
                <input
                  type="text"
                  ref={courseref}
                  name="course"
                  value={ResumeStore.resumeBuilder.courses[index]?.course}
                  onChange={(e) => updateCourses(e, index)}
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Institution</label>
                <input
                  name="institution"
                  value={ResumeStore.resumeBuilder.courses[index]?.institution}
                  onChange={(e) => updateCourses(e, index)}
                  ref={institutionref}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Start Date</label>
                <input
                  name="startDate"
                  value={ResumeStore.resumeBuilder.courses[index]?.startDate}
                  onChange={(e) => updateCourses(e, index)}
                  ref={startDateref}
                  type="date"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">End Date</label>
                <input
                  name="endDate"
                  value={ResumeStore.resumeBuilder.courses[index]?.endDate}
                  onChange={(e) => updateCourses(e, index)}
                  ref={endDateref}
                  type="date"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold">Courses</h1>
      {ResumeStore.resumeBuilder.courses.map((item, index) => (
        <Details index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.courses.length > 0
          ? " Add one more Course"
          : " Add Course"}{" "}
      </button>
    </>
  ));
}

export function Internships({ handleShowInternships }) {
  // const [internships, setInternships] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  // const [showDelete, setShowDelete] = useState(false);
  const { ResumeStore } = useStores();

  const titleRef = useRef(null);
  const employerRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const cityRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleAdd = () => {
    // setInternships([...internships, {}])
    ResumeStore.setInternships({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setInternships(internships.filter((item,index) => index !== internships.length - 1))
    ResumeStore.removeInternships(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateInternship = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateInternships(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm ">
              {ResumeStore.resumeBuilder.internships[index]?.jobTitle ||
                "Add Jobtitle"}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between ">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Job Title</label>
                <input
                  type="text"
                  name="jobTitle"
                  value={ResumeStore.resumeBuilder.internships[index]?.jobTitle}
                  onChange={(e) => updateInternship(e, index)}
                  ref={titleRef}
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Employer</label>
                <input
                  ref={employerRef}
                  name="employer"
                  value={ResumeStore.resumeBuilder.internships[index]?.employer}
                  onChange={(e) => updateInternship(e, index)}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Start Date</label>
                <input
                  name="startDate"
                  value={
                    ResumeStore.resumeBuilder.internships[index]?.startDate
                  }
                  onChange={(e) => updateInternship(e, index)}
                  ref={startDateRef}
                  type="date"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">End Date</label>
                <input
                  name="endDate"
                  value={ResumeStore.resumeBuilder.internships[index]?.endDate}
                  onChange={(e) => updateInternship(e, index)}
                  ref={endDateRef}
                  type="date"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">City</label>
                <input
                  name="city"
                  value={ResumeStore.resumeBuilder.internships[index]?.city}
                  onChange={(e) => updateInternship(e, index)}
                  ref={cityRef}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="my-2 w-full">
                <label className="text-sm text-text_color5">Description</label>
                <textarea
                  name="description"
                  value={
                    ResumeStore.resumeBuilder.internships[index]?.description
                  }
                  onChange={(e) => updateInternship(e, index)}
                  ref={descriptionRef}
                  className="w-full bg-gray-300 focus:outline-none md:h-[40vh] lg:h-[40vh] h-[30vh] p-2"
                  placeholder="e.g. ....."
                />
                <div className="text-text_color5 text-sm flex justify-between items-center">
                  <p className="md:w-[90%] lg:w-[90%] w-[80%]">
                    Recruiter tip: write 50-200 characters to increase interview
                    chances
                  </p>
                  <p>0 / 50+</p>
                </div>
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold flex items-center">Internships </h1>
      {ResumeStore.resumeBuilder.internships.map((item, index) => (
        <Details index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.internships.length > 0
          ? " Add one more Internship"
          : " Add Internship"}{" "}
      </button>
    </>
  ));
}

export function References() {
  // const [references, setReferences] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ResumeStore } = useStores();

  const nameref = useRef(null);
  const companyref = useRef(null);
  const emailref = useRef(null);
  const phoneref = useRef(null);

  const handleAdd = () => {
    // setReferences([...references, {}])
    ResumeStore.setReferences({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setReferences(references.filter((item,index) => index !== references.length - 1))
    ResumeStore.removeReferences(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateReferences = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateReferences(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm ">
              {ResumeStore.resumeBuilder.references[index]?.referentsName || ""}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between ">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">
                  Referent's Full Name
                </label>
                <input
                  type="text"
                  name="referentsName"
                  value={
                    ResumeStore.resumeBuilder.references[index]?.referentsName
                  }
                  onChange={(e) => updateReferences(e, index)}
                  ref={nameref}
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Company</label>
                <input
                  ref={companyref}
                  name="company"
                  value={ResumeStore.resumeBuilder.references[index]?.company}
                  onChange={(e) => updateReferences(e, index)}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Phone</label>
                <input
                  name="phone"
                  value={ResumeStore.resumeBuilder.references[index]?.phone}
                  onChange={(e) => updateReferences(e, index)}
                  ref={phoneref}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Email</label>
                <input
                  ref={emailref}
                  name="email"
                  value={ResumeStore.resumeBuilder.references[index]?.email}
                  onChange={(e) => updateReferences(e, index)}
                  type="email"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold lg:text-3xl">References</h1>
      {ResumeStore.resumeBuilder.references.map((item, index) => (
        <Details index={index} />
      ))}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.references.length > 0
          ? " Add one more Reference"
          : " Add Reference"}{" "}
      </button>
    </>
  ));
}

export function Hobbies({ handleShowHobbies }) {
  const [hobbies, setHobbies] = useState([]);
  const [showHobbies, setShowHobbies] = useState(true);
  const HobbyInputRef = useRef(null);
  const { ResumeStore } = useStores();

  const addHobbies = () => {
    setShowHobbies(true);
    if (HobbyInputRef.current.value !== "") {
      // setHobbies([...hobbies, HobbyInputRef.current.value]);
      ResumeStore.setHobbies(HobbyInputRef.current.value);
    }
    console.log(toJS(ResumeStore.resumeBuilder.hobbies));
    HobbyInputRef.current.value = "";
  };

  const removeHobby = (index) => {
    // setHobbies(hobbies.filter((item,index) => index !== hobbies.length - 1))
    ResumeStore.removeHobbies(index);
    console.log(toJS(ResumeStore.resumeBuilder.hobbies));
  };

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold">Hobbies</h1>
      <label className="text-text_color5 mt-1">Hobbies you have </label>
      <div className="flex flex-row">
        <input
          type="text"
          ref={HobbyInputRef}
          className="px-2 py-3 mt-1 w-full bg-secondary2 focus:outline-none"
        />
        <button
          onClick={() => addHobbies()}
          className="bg-primary  text-bg3 mx-1 py-1 px-4 rounded-lg "
        >
          Add
        </button>
      </div>
      {showHobbies && (
        <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
          {ResumeStore.resumeBuilder.hobbies.map((hobby, index) => (
            <div
              className="flex relative flex-row justify-end pt-2"
              key={index}
            >
              {/* <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div> */}
              <AiFillCloseCircle
                className="absolute cursor-pointer md:my-0 lg:my-0 mb-2 mr-[-10px]"
                onClick={() => {
                  removeHobby(index);
                }}
              />
              <p className="text-[15px]   rounded-lg  bg-primary  text-bg3 py-1 px-4">
                {hobby}
              </p>
            </div>
          ))}
        </div>
      )}
    </>
  ));
}

export function ExtraCurricular({ handleShowExtraCurricular }) {
  // const [activities, setActivities] = useState([]);
  const [showDetails, setShowDetails] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  // const [showDelete, setShowDelete] = useState(false);
  const { ResumeStore } = useStores();

  const titleRef = useRef(null);
  const employerRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const cityRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleAdd = () => {
    // setActivities([...activities, {}])
    ResumeStore.setExtraCurricularActivities({});
    setShowDetails([...showDetails, false]);
  };

  const handleRemove = (index) => {
    // setActivities(activities.filter((item,index) => index !== activities.length - 1))
    ResumeStore.removeExtraCurricularActivities(index);
    setShowDetails(showDetails.filter((_, i) => i !== index));
  };

  const handleToggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = prevShowDetails.map((_, i) =>
        i === index ? !prevShowDetails[i] : false
      );
      return newShowDetails;
    });
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const updateExtraCurricular = (e, index) => {
    const name = e.target?.name;
    const value = e.target?.value;
    ResumeStore.updateExtraCurricularActivities(name, value, index);
  };

  function Details({ index }) {
    const isHovered = hoveredIndex === index;

    return useObserver(() => (
      <div
        key={index}
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        className="flex"
      >
        <div
          className={`w-[95%] my-2 ${
            showDetails ? "border  border-text_color5 bg-secondary2" : null
          }`}
        >
          <div
            onClick={() => handleToggleDetails(index)}
            className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}
          >
            <p className="text-sm ">
              {ResumeStore.resumeBuilder.extraCurricularActivities[index]
                ?.functionTitle || "Add an extraCurrical activity"}
            </p>

            {showDetails[index] ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </div>

          {showDetails[index] && (
            <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between ">
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">
                  Function Title
                </label>
                <input
                  type="text"
                  name="functionTitle"
                  value={
                    ResumeStore.resumeBuilder.extraCurricularActivities[index]
                      ?.functionTitle
                  }
                  onChange={(e) => updateExtraCurricular(e, index)}
                  ref={titleRef}
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Employer</label>
                <input
                  ref={employerRef}
                  name="employer"
                  value={
                    ResumeStore.resumeBuilder.extraCurricularActivities[index]
                      ?.employer
                  }
                  onChange={(e) => updateExtraCurricular(e, index)}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">Start Date</label>
                <input
                  ref={startDateRef}
                  name="startDate"
                  value={
                    ResumeStore.resumeBuilder.extraCurricularActivities[index]
                      ?.startDate
                  }
                  onChange={(e) => updateExtraCurricular(e, index)}
                  type="date"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">End Date</label>
                <input
                  name="endDate"
                  value={
                    ResumeStore.resumeBuilder.extraCurricularActivities[index]
                      ?.endDate
                  }
                  onChange={(e) => updateExtraCurricular(e, index)}
                  ref={endDateRef}
                  type="date"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                  // placeholder="MM / YYYY"
                />
              </div>
              <div className="flex flex-col my-2 w-[45%] items-start">
                <label className="text-sm text-text_color5">City</label>
                <input
                  name="city"
                  value={
                    ResumeStore.resumeBuilder.extraCurricularActivities[index]
                      ?.city
                  }
                  onChange={(e) => updateExtraCurricular(e, index)}
                  ref={cityRef}
                  type="text"
                  className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"
                />
              </div>
              <div className="my-2 w-full">
                <label className="text-sm text-text_color5">Description</label>
                <textarea
                  name="description"
                  value={
                    ResumeStore.resumeBuilder.extraCurricularActivities[index]
                      ?.description
                  }
                  onChange={(e) => updateExtraCurricular(e, index)}
                  ref={descriptionRef}
                  className="w-full bg-gray-300 focus:outline-none md:h-[40vh] lg:h-[40vh] h-[30vh] p-2"
                  placeholder="e.g. ....."
                />
              </div>
            </div>
          )}
        </div>
        {isHovered && (
          <MdDeleteOutline
            onClick={() => handleRemove(index)}
            className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 "
          />
        )}
      </div>
    ));
  }

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold flex items-center">
        Extra-Curricular Activities
      </h1>
      {ResumeStore.resumeBuilder.extraCurricularActivities.map(
        (item, index) => (
          <Details index={index} />
        )
      )}
      <button
        onClick={handleAdd}
        className="text-primary flex items-center mt-1"
      >
        <FaPlus className="mr-1" />
        {ResumeStore.resumeBuilder.extraCurricularActivities.length > 0
          ? " Add one more Activity"
          : " Add Activity"}{" "}
      </button>
    </>
  ));
}

// export function CustomSection({handleRemoveCustomSection,index}){
//     const [sections, setSections] = useState([]);
//     const [showDetails, setShowDetails] = useState([]);
//     const [hoveredIndex, setHoveredIndex] = useState(null);
//     const [showDelete, setShowDelete] = useState(false);

//     const titleRef = useRef(null);
//     const cityRef = useRef(null);
//     const startDateRef = useRef(null);
//     const endDateRef = useRef(null);
//     const descriptionRef = useRef(null);

//     const handleAdd = () => {
//         setSections([...sections, {}])
//         setShowDetails([...showDetails, false]);
//     }

//     const handleRemove = (index) => {
//         setSections(sections.filter((item,index) => index !== sections.length - 1))
//         setShowDetails(showDetails.filter((_, i) => i !== index));
//     }

//     const handleInputChange = (index, field, value) => {
//         setSections((prevHistory) => {
//           const newHistory = [...prevHistory];
//           newHistory[index][field] = value;
//           return newHistory;
//         });
//     };

//     const handleToggleDetails = (index) => {
//         setShowDetails((prevShowDetails) => {
//         const newShowDetails = prevShowDetails.map((_, i) => (i === index ? !prevShowDetails[i] : false));
//         return newShowDetails;
//         });
//     };

//   const handleMouseEnter = (index) => {
//     setHoveredIndex(index);
//   };

//   const handleMouseLeave = () => {
//     setHoveredIndex(null);
//   };

//     function Details({index}){
//         const isHovered = hoveredIndex === index;

//     return (
//        <div key={index}
//        onMouseEnter={() => handleMouseEnter(index)}
//         onMouseLeave={handleMouseLeave}
//         className="flex">
//          <div
//          className={`w-[95%] my-2 ${showDetails ? "border  border-text_color5 bg-secondary2" : null}`}>

//            <div onClick={() => handleToggleDetails(index)}
//             className={`w-full p-4 cursor-pointer flex items-center justify-between bg-secondary2`}>

//                <p className="text-sm ">{sections[index].title || '(Not specified)'}</p>

//            {showDetails[index] ? <IoIosArrowUp/> :  <IoIosArrowDown/>}

//             </div>

//        {showDetails[index] && (
//        <div className="flex mx-2 flex-wrap w-[95%] mt-2 justify-between ">
//            <div className="flex flex-col my-2 w-[45%] items-start">
//                <label className="text-sm text-text_color5">Aсtivity name, job title, book title etc.</label>
//                <input type="text"
//                ref={titleRef}
//                 className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none"/>
//            </div>
//            <div className="flex flex-col my-2 w-[45%] items-start">
//                <label className="text-sm text-text_color5">City</label>
//                <input ref={cityRef}
//                 type="text" className="px-2 py-3 mt-1 w-full bg-gray-300 focus:outline-none" />
//            </div>
//            <div className="flex flex-col my-2 w-[45%] items-start">
//            <label className="text-sm text-text_color5">Start & End Date</label>
//                <div className="flex items-center justify-between">

//                <input ref={startDateRef} type="text" className="px-2 py-3 mt-1 w-[45%] bg-gray-300 focus:outline-none" placeholder="MM / YYYY" />
//                <input ref={endDateRef} type="text" className="px-2 py-3 mt-1 w-[45%] bg-gray-300 focus:outline-none ml-2" placeholder="MM / YYYY" />
//                </div>
//            </div>

//            <div className="my-2 w-full">
//                <label className="text-sm text-text_color5">Description</label>
//                <textarea ref={descriptionRef} className="w-full bg-gray-300 focus:outline-none h-[40vh] p-2" placeholder="e.g. ....."/>
//        </div>
//        </div>
//        )}

//        </div>
//        {
//         isHovered && (
//         <MdDeleteOutline
//          onClick={()=>handleRemove(index)}
//           className="text-xl cursor-pointer mt-6 w-[5%] text-text_color5 " />
//         )}
//        </div>
//     )}

//     return (
//         <>
//         <h1 onMouseEnter={()=>setShowDelete(true)} onMouseLeave={()=> setShowDelete(false)} className="text-2xl flex items-center font-semibold">Untitled {showDelete ? <MdDeleteOutline onClick={()=>handleRemoveCustomSection(index)} className="ml-1 text-text_color5 text-xl cursor-pointer"/> : null}</h1>
//         {sections.map((item,index) => (
//             <Details index={index} />
//         ))}
//         <button onClick={handleAdd} className="text-primary flex items-center mt-1"><FaPlus className="mr-1" />{sections.length > 0 ? " Add one more item": " Add item"} </button>
//         </>
//     )
// }

export function Skills() {
  //   const [skills, setSkills] = useState([]);
  const [showSkills, setShowSkills] = useState(true);
  const skillInputRef = useRef(null);
  const { ResumeStore } = useStores();

  const addSkills = () => {
    setShowSkills(true);
    if (skillInputRef.current.value !== "") {
      //   setSkills([...skills, skillInputRef.current.value]);
      ResumeStore.setSkills(skillInputRef.current.value);
      console.log(toJS(ResumeStore.resumeBuilder.skills));
    }

    skillInputRef.current.value = "";
    // setSkills("");
  };

  const removeSkill = (index) => {
    // setSkills(skills.filter((item,index) => index !== skills.length - 1))
    ResumeStore.removeSkills(index);
    console.log(toJS(ResumeStore.resumeBuilder.skills));
  };

  return useObserver(() => (
    <>
      <h1 className="text-2xl font-semibold">Skills</h1>
      <label className="text-text_color5 mt-1">skills you have </label>
      <div className="flex flex-row gap-2">
        <input
          type="text"
          ref={skillInputRef}
          className="px-2 py-3 mt-1 w-full bg-secondary2 focus:outline-none"
        />
        <button
          onClick={() => addSkills()}
          className="bg-primary  text-bg3 mx-1 py-1 mt-1 px-4 rounded-lg "
        >
          Add
        </button>
      </div>
      {showSkills && (
        <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
          {ResumeStore.resumeBuilder.skills.map((skill, index) => (
            <div
              className="flex relative flex-row justify-end pt-2"
              key={index}
            >
              {/* <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div> */}
              <AiFillCloseCircle
                className="absolute cursor-pointer md:my-0 lg:my-0 mb-2 mr-[0px]"
                onClick={() => {
                  removeSkill(index);
                }}
              />
              <p className="text-[15px]   rounded-lg  bg-primary  text-bg3 py-1 px-4">
                {skill}
              </p>
            </div>
          ))}
        </div>
      )}
    </>
  ));
}

export function AddSection({
  handleShowLanguages,
  handleShowCourses,
  handleShowInternships,
  handleShowReferences,
  handleShowHobbies,
  handleShowExtraCurricular,
  language,
  course,
  internship,
  reference,
  hobbies,
  extraCurricular,
}) {
  const [showLanguages, setShowLanguages] = useState(language);
  const [showCourses, setShowCourses] = useState(course);
  const [showInternships, setShowInternships] = useState(internship);
  const [showReferences, setShowReferences] = useState(reference);
  const [showHobbies, setShowHobbies] = useState(hobbies);
  const [showExtraCurricular, setShowExtraCurricular] =
    useState(extraCurricular);
  // const [showCustomSection, setShowCustomSection] = useState(customSection);

  // const handleCustom = () => {
  //     if(handleAddCustomSection){
  //         handleAddCustomSection();
  //     }
  //     if(handleShowCustomSection){
  //         handleShowCustomSection();
  //     }
  //     setShowCustomSection(true);
  // }

  const handleCourse = () => {
    // console.log("hello");
    if (handleShowCourses) {
      handleShowCourses();
    }
    setShowCourses(!showCourses);
  };

  const handleExtras = () => {
    if (handleShowExtraCurricular) {
      handleShowExtraCurricular();
    }
    setShowExtraCurricular(!showExtraCurricular);
  };

  const handleInternship = () => {
    if (handleShowInternships) {
      handleShowInternships();
    }
    setShowInternships(!showInternships);
  };

  const handleHobbies = () => {
    if (handleShowHobbies) {
      handleShowHobbies();
    }
    setShowHobbies(!showHobbies);
  };

  const handleLanguage = () => {
    if (handleShowLanguages) {
      handleShowLanguages();
    }
    setShowLanguages(!showLanguages);
  };

  const handleRefernce = () => {
    if (handleShowReferences) {
      handleShowReferences();
    }
    setShowReferences(!showReferences);
  };

  return (
    <>
      <h1 className="text-2xl font-semibold">Add Section</h1>
      <div className="md:w-[90%] lg:w-[90%] w-full  flex flex-wrap items-center ">
        {/* <button onClick={handleCustom} className={`w-[45%] my-2  flex items-center`}><MdDashboardCustomize className={`text-primary text-2xl mr-1`} /> Custom Section</button> */}
        <button
          onClick={handleCourse}
          disabled={showCourses}
          className={`w-[45%] my-2 ${
            showCourses ? "text-text_color5" : "text-black"
          } flex items-center`}
        >
          <SiCoursera
            className={`${
              showCourses ? "text-text_color5" : "text-primary"
            } text-2xl mr-1`}
          />{" "}
          Courses
        </button>
        <button
          onClick={handleExtras}
          disabled={showExtraCurricular}
          className={`w-[55%] my-2 ${
            showExtraCurricular ? "text-text_color5" : "text-black"
          } flex items-center text-left`}
        >
          <RiPlantFill
            className={`${
              showExtraCurricular ? "text-text_color5" : "text-primary"
            } text-[1.9rem] mr-1`}
          />{" "}
          Extra-Curricular Activities
        </button>
        <button
          onClick={handleInternship}
          disabled={showInternships}
          className={`w-[45%] my-2 ${
            showInternships ? "text-text_color5" : "text-black"
          } flex items-center`}
        >
          <RiSuitcaseLine
            className={`${
              showInternships ? "text-text_color5" : "text-primary"
            } text-2xl mr-1`}
          />{" "}
          Internships
        </button>
        <button
          onClick={handleHobbies}
          disabled={showHobbies}
          className={`w-[45%] my-2 ${
            showHobbies ? "text-text_color5" : "text-black"
          } flex items-center`}
        >
          <FaChessRook
            className={`${
              showHobbies ? "text-text_color5" : "text-primary"
            } text-2xl mr-1`}
          />{" "}
          Hobbies
        </button>
        <button
          onClick={handleLanguage}
          disabled={showLanguages}
          className={`w-[45%] my-2 ${
            showLanguages ? "text-text_color5" : "text-black"
          } flex items-center`}
        >
          <FaLanguage
            className={`${
              showLanguages ? "text-text_color5" : "text-primary"
            } text-2xl mr-1`}
          />
          Languages
        </button>
        <button
          onClick={handleRefernce}
          disabled={showReferences}
          className={`w-[45%] my-2 ${
            showReferences ? "text-text_color5" : "text-black"
          } flex items-center`}
        >
          <HiSpeakerphone
            className={`${
              showReferences ? "text-text_color5" : "text-primary"
            } text-2xl mr-1`}
          />{" "}
          References
        </button>
      </div>
    </>
  );
}
